import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Item from "./Item";

class Highlights extends Component {
    render() {
        const { title, highlights } = this.props;

        return (
            <div className="pb-40 xl:pb-60 bg-pink">
                <h1 className="font-judge font-bold text-50 xl:text-100 text-blue text-center py-40 xl:py-80">
                    {title}
                </h1>
                <div className="grid px-16 xl:px-50 md:grid-cols-2 xl:grid-cols-3 gap-x-30 gap-y-50 xl:gap-y-60">
                    {highlights.map((item) => (
                        <Item key={item.key} item={item.attributes} />
                    ))}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Highlights);
